/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesChampionMasterySchema } from "./championMasterySchema.ts";
import { goodLuckCoreEntitiesDiscordAuthSchema } from "./discordAuthSchema.ts";
import { goodLuckCoreEntitiesDraftPlayerSchema } from "./draftPlayerSchema.ts";
import { goodLuckCoreEntitiesDraftTeamSchema } from "./draftTeamSchema.ts";
import { goodLuckCoreEntitiesFavoriteChampionSchema } from "./favoriteChampionSchema.ts";
import { goodLuckCoreEntitiesFriendRequestSchema } from "./friendRequestSchema.ts";
import { goodLuckCoreEntitiesGoogleAuthSchema } from "./googleAuthSchema.ts";
import { goodLuckCoreEntitiesOrganizationInvitationSchema } from "./organizationInvitationSchema.ts";
import { goodLuckCoreEntitiesOrganizationMemberSchema } from "./organizationMemberSchema.ts";
import { goodLuckCoreEntitiesProNicknameStyleSchema } from "./proNicknameStyleSchema.ts";
import { goodLuckCoreEntitiesRiotAccountSchema } from "./riotAccountSchema.ts";
import { goodLuckCoreEntitiesRosterMemberSchema } from "./rosterMemberSchema.ts";
import { goodLuckCoreEntitiesTwitchAuthSchema } from "./twitchAuthSchema.ts";
import { goodLuckCoreEntitiesUserAchievementSchema } from "./userAchievementSchema.ts";
import { goodLuckCoreEntitiesUserFriendSchema } from "./userFriendSchema.ts";
import { goodLuckCoreEntitiesUserNotificationSettingsSchema } from "./userNotificationSettingsSchema.ts";
import { goodLuckCoreEntitiesUserPrivacySettingsSchema } from "./userPrivacySettingsSchema.ts";
import { goodLuckCoreEntitiesUserRoleSchema } from "./userRoleSchema.ts";
import { goodLuckCoreEntitiesUserSocialLinksSchema } from "./userSocialLinksSchema.ts";
import { goodLuckCoreEntitiesUserStatsSchema } from "./userStatsSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesUserSchema = z.object({
  id: z.string().nullish(),
  username: z.string().min(1),
  displayName: z.string().min(1),
  avatarUrl: z.string().nullish(),
  banner: z.string().nullish(),
  about: z.string().nullish(),
  location: z.string().nullish(),
  languages: z.array(z.string()).nullish(),
  website: z.string().nullish(),
  email: z.string().nullish(),
  passwordHash: z.string().nullish(),
  passwordLastChanged: z.iso.datetime().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  isActive: z.optional(z.boolean()),
  isEmailVerified: z.optional(z.boolean()),
  hasPro: z.optional(z.boolean()),
  get proNicknameStyle() {
    return goodLuckCoreEntitiesProNicknameStyleSchema.optional();
  },
  proNicknameColorA: z.string().max(7).nullish(),
  proNicknameColorB: z.string().max(7).nullish(),
  isVerified: z.optional(z.boolean()),
  verificationReason: z.string().max(500).nullish(),
  verificationUpdatedAt: z.iso.datetime().nullish(),
  verificationUpdatedByUserId: z.string().max(255).nullish(),
  isOnline: z.optional(z.boolean()),
  status: z.string().max(20).nullish(),
  statusExpiresAtUtc: z.iso.datetime().nullish(),
  customStatusText: z.string().max(64).nullish(),
  customStatusEmoji: z.string().max(16).nullish(),
  customStatusExpiresAtUtc: z.iso.datetime().nullish(),
  lastActivity: z.iso.datetime().nullish(),
  lastTauriHeartbeatAt: z.iso.datetime().nullish(),
  pdnConsentAt: z.iso.datetime().nullish(),
  pdnConsentVersion: z.string().max(32).nullish(),
  isBanned: z.optional(z.boolean()),
  bannedAt: z.iso.datetime().nullish(),
  bannedByUserId: z.string().nullish(),
  banReason: z.string().nullish(),
  get bannedByUser() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  isMuted: z.optional(z.boolean()),
  mutedUntil: z.iso.datetime().nullish(),
  preferredRole: z.string().max(20).nullish(),
  secondaryRole: z.string().max(20).nullish(),
  deletedAt: z.iso.datetime().nullish(),
  originalUsername: z.string().nullish(),
  originalDisplayName: z.string().nullish(),
  originalAvatarUrl: z.string().nullish(),
  originalBanner: z.string().nullish(),
  get socialLinks() {
    return goodLuckCoreEntitiesUserSocialLinksSchema.optional();
  },
  get stats() {
    return goodLuckCoreEntitiesUserStatsSchema.optional();
  },
  get privacySettings() {
    return goodLuckCoreEntitiesUserPrivacySettingsSchema.optional();
  },
  get notificationSettings() {
    return goodLuckCoreEntitiesUserNotificationSettingsSchema.optional();
  },
  get achievements() {
    return z.array(goodLuckCoreEntitiesUserAchievementSchema).nullish();
  },
  get favoriteChampions() {
    return z.array(goodLuckCoreEntitiesFavoriteChampionSchema).nullish();
  },
  get championMasteries() {
    return z.array(goodLuckCoreEntitiesChampionMasterySchema).nullish();
  },
  get rosterMemberships() {
    return z.array(goodLuckCoreEntitiesRosterMemberSchema).nullish();
  },
  get organizationMemberships() {
    return z.array(goodLuckCoreEntitiesOrganizationMemberSchema).nullish();
  },
  get sentOrganizationInvitations() {
    return z.array(goodLuckCoreEntitiesOrganizationInvitationSchema).nullish();
  },
  get receivedOrganizationInvitations() {
    return z.array(goodLuckCoreEntitiesOrganizationInvitationSchema).nullish();
  },
  get userRoles() {
    return z.array(goodLuckCoreEntitiesUserRoleSchema).nullish();
  },
  get discordAuth() {
    return goodLuckCoreEntitiesDiscordAuthSchema.optional();
  },
  get googleAuth() {
    return goodLuckCoreEntitiesGoogleAuthSchema.optional();
  },
  get twitchAuth() {
    return goodLuckCoreEntitiesTwitchAuthSchema.optional();
  },
  get riotAccounts() {
    return z.array(goodLuckCoreEntitiesRiotAccountSchema).nullish();
  },
  get draftPlayers() {
    return z.array(goodLuckCoreEntitiesDraftPlayerSchema).nullish();
  },
  get captainedDraftTeams() {
    return z.array(goodLuckCoreEntitiesDraftTeamSchema).nullish();
  },
  get sentFriendRequests() {
    return z.array(goodLuckCoreEntitiesFriendRequestSchema).nullish();
  },
  get receivedFriendRequests() {
    return z.array(goodLuckCoreEntitiesFriendRequestSchema).nullish();
  },
  get friendsAsUser() {
    return z.array(goodLuckCoreEntitiesUserFriendSchema).nullish();
  },
  get friendsAsFriend() {
    return z.array(goodLuckCoreEntitiesUserFriendSchema).nullish();
  },
});
